module.exports = "/fonts/vendor/quasar-extras/fontawesome/fa-regular-400.woff?0b5e3a5451fc62d9023ccafc85bc89db";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/fontawesome/fa-regular-400.woff
// module id = cgSx
// module chunks = 49